var chunkMapping = {
	"1": [
		15,
		1271,
		1452,
		2653,
		3152,
		3177,
		5333,
		5515,
		6941
	],
	"4": [
		5004
	],
	"11": [
		2011
	],
	"31": [
		31
	],
	"35": [
		8035
	],
	"47": [
		9047
	],
	"83": [
		83
	],
	"104": [
		104
	],
	"115": [
		115
	],
	"129": [
		6129
	],
	"147": [
		7147
	],
	"161": [
		8161
	],
	"194": [
		2194
	],
	"210": [
		1210
	],
	"216": [
		216
	],
	"219": [
		3219
	],
	"222": [
		4222
	],
	"263": [
		3263
	],
	"278": [
		3278
	],
	"420": [
		8420
	],
	"465": [
		7465
	],
	"507": [
		9507
	],
	"510": [
		4510
	],
	"578": [
		1578
	],
	"580": [
		2580
	],
	"595": [
		7595
	],
	"646": [
		9646
	],
	"653": [
		5034
	],
	"699": [
		5699
	],
	"700": [
		3700
	],
	"701": [
		6701
	],
	"721": [
		4721
	],
	"915": [
		6915
	],
	"919": [
		9919
	],
	"926": [
		2926
	],
	"958": [
		6958
	],
	"988": [
		3988
	],
	"991": [
		4991
	]
};
var idToExternalAndNameMapping = {
	"15": [
		"default",
		"./store",
		9875
	],
	"31": [
		"default",
		"./Provider",
		8455
	],
	"83": [
		"default",
		"./InsurancesAdmin",
		59
	],
	"104": [
		"default",
		"./ConfirmationForm",
		59
	],
	"115": [
		"default",
		"./BillingAdmin",
		59
	],
	"216": [
		"default",
		"./UsersAdmin",
		59
	],
	"1210": [
		"default",
		"./ReportsSummaries",
		59
	],
	"1271": [
		"default",
		"./fnxUtils",
		9875
	],
	"1452": [
		"default",
		"./LocalStorage",
		9875
	],
	"1578": [
		"default",
		"./CollectAdmin",
		59
	],
	"2011": [
		"default",
		"./PropertiesAdmin",
		59
	],
	"2194": [
		"default",
		"./CobranzaAdmin",
		59
	],
	"2580": [
		"default",
		"./Completed",
		59
	],
	"2653": [
		"default",
		"./WorkflowApp",
		9644
	],
	"2926": [
		"default",
		"./CalculatePremium",
		59
	],
	"3152": [
		"default",
		"./Loading",
		9875
	],
	"3177": [
		"default",
		"./WorkflowCreateApp",
		9644
	],
	"3219": [
		"default",
		"./CustomReportPage",
		59
	],
	"3263": [
		"default",
		"./AccountTypeAdmin",
		59
	],
	"3278": [
		"default",
		"./BranchesAdmin",
		59
	],
	"3700": [
		"default",
		"./InsuranceTypeAdmin",
		59
	],
	"3988": [
		"default",
		"./CataloguesAdmin",
		59
	],
	"4222": [
		"default",
		"./RegionAdmin",
		59
	],
	"4510": [
		"default",
		"./PaymentConfirmation",
		59
	],
	"4721": [
		"default",
		"./PassengerForm",
		59
	],
	"4991": [
		"default",
		"./Clients",
		59
	],
	"5004": [
		"default",
		"./AddBusiness",
		59
	],
	"5034": [
		"default",
		"./RolAdmin",
		59
	],
	"5333": [
		"default",
		"./FormsApp",
		9532
	],
	"5515": [
		"default",
		"./FlowApp",
		7760
	],
	"5699": [
		"default",
		"./InsurancePoliciesSummary",
		59
	],
	"6129": [
		"default",
		"./PermissionAdmin",
		59
	],
	"6701": [
		"default",
		"./ProjectTypeAdmin",
		59
	],
	"6915": [
		"default",
		"./ClientRecord",
		59
	],
	"6941": [
		"default",
		"./NotFound",
		9875
	],
	"6958": [
		"default",
		"./CustomerForms",
		59
	],
	"7147": [
		"default",
		"./MasterApp",
		5252
	],
	"7465": [
		"default",
		"./PlanAdmin",
		59
	],
	"7595": [
		"default",
		"./InitialInfo",
		59
	],
	"8035": [
		"default",
		"./AuditPage",
		59
	],
	"8161": [
		"default",
		"./ProductCreation",
		59
	],
	"8420": [
		"default",
		"./Plan",
		59
	],
	"9047": [
		"default",
		"./authApp",
		8455
	],
	"9507": [
		"default",
		"./PaymentSummary",
		59
	],
	"9646": [
		"default",
		"./PlanDetails",
		59
	],
	"9919": [
		"default",
		"./PlanCreation",
		59
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}